import { BASE_URL } from "../../helpers/config";

const recentReports = new Map();
const REPORT_DEDUP_WINDOW_MS = 60_000;

const normalizeError = (reason) => {
  if (reason instanceof Error) {
    return { message: reason.message || reason.name, stack: reason.stack || "" };
  }
  if (typeof reason === "string") {
    return { message: reason, stack: "" };
  }

  return {
    message: reason?.message || reason?.reason?.message || "Unknown frontend runtime error",
    stack: reason?.stack || reason?.reason?.stack || "",
  };
};

export const reportRuntimeError = (reason, context = {}) => {
  if (typeof window === "undefined" || process.env.NODE_ENV === "test") return;

  const error = normalizeError(reason);
  const signature = `${context.kind || "runtime"}:${error.message}:${window.location.pathname}`;
  const now = Date.now();
  if (now - Number(recentReports.get(signature) || 0) < REPORT_DEDUP_WINDOW_MS) return;
  recentReports.set(signature, now);

  const payload = {
    kind: context.kind || "runtime",
    message: error.message.slice(0, 2000),
    stack: error.stack.slice(0, 12000),
    component_stack: String(context.componentStack || "").slice(0, 12000),
    url: window.location.href.slice(0, 2048),
    release: process.env.REACT_APP_RELEASE || "akas-fe-local",
  };

  window.fetch(`${BASE_URL}/client-errors`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
};
